import { ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyTermsSuccessFormComponent } from './pass-key-terms-success-form.component';

class PassKeySuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  isSuccess: boolean;;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  passKeyTermsSuccessFormComponent: ComponentRef<PassKeyTermsSuccessFormComponent>;

  constructor(formId: string, payload: object) {
    this.isSuccess = payload['success'];
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;
  }
  endSession(): void {

  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {

    this.viewContainerRef.clear();

    this.passKeyTermsSuccessFormComponent = this.viewContainerRef.createComponent(PassKeyTermsSuccessFormComponent);

    this.passKeyTermsSuccessFormComponent.instance.isSuccess = this.isSuccess;
    this.passKeyTermsSuccessFormComponent.instance.onPasskeySuccessContinueSubmit = this.onPasskeySuccess.bind(this);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onPasskeySuccess(payload: object) {
    const data = payload;
    this.submitBlock(data);
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeySuccessFormSession;
